import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {Grandmaster} from "lo-bahamut";
import { SharedModule } from '../_shared/shared.module';
import { CustomCarouselModule } from '../_shared/custom-carousel/custom-carousel.module';
import { ComingSoonModule } from '../coming-soon/coming-soon.module';
import {IFrameComponent} from "./iframe.component";
import {PrintSearchResultsModule} from "../search-results/print-search-results/print-search-results.module";

import {ComponentTesterComponent} from "./component-tester.component";

@NgModule({
  declarations: [IFrameComponent, ComponentTesterComponent ],
    imports: [
        ComingSoonModule,
        CommonModule,
        FormsModule,
        SharedModule,
        CustomCarouselModule,
        Grandmaster,
        PrintSearchResultsModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IFrameModule {}
